import qs from "qs"
import { get, partial } from "lodash-es"

export const bigCostDollars = (number) => {
  if (number > 1000000000) {
    return `$${Math.round(number / 1000000) / 10} Billion`
  } else if (number < 1000000) {
    return `$${Math.round(number / 1000) / 1}K`
  }

  return `$${Math.round(number / 100000) / 10} Million`
}

export const config = partial(get, window.config || {})

// eslint-disable-next-line no-confusing-arrow
export const currency = (number, digits = 2) => `$${parseFloat((number || 0).toFixed(digits)).toLocaleString()}`

export const currencyShort = (number) => {
  if (number > 1000000000) {
    return `$${Math.round(number / 1000000) / 10} billion`
  }

  if (number > 1000000) {
    return `$${Math.round(number / 100000) / 10} million`
  }

  if (number > 9999) {
    return `$${Math.round(number / 1000)}k`
  }

  return `$${Math.round(number).toLocaleString()}`
}

export const findComponents = files => {
  return Object.fromEntries(files.keys().map(path => [path.replace(/^.*\/(.*)\.vue$/, "$1"), files(path).default]))
}

export const isFloat = (subject) => parseFloat(subject?.match && subject.match(/^-?\d*(\.\d+)?$/)) > 0

export const meta = name => document.querySelector(`meta[name="${name}"]`)?.content

export const numberFormat = (subject) => subject?.replace && subject.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")

export const params = (url, params = {}) => url + qs.stringify(params, {
  addQueryPrefix: true,
  skipNulls: true,
})

// Convert to percent with 1 decimal place
export const percent = (numerator, denominator) => Math.round(numerator / denominator * 1000) / 10

export const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time))
